import { CivilDate } from 'tc39-proposal-temporal';
import {
  getCivilDateToday,
  compareCivilDate,
} from '@bingads-webui-universal/temporal-utitlities';

export const civilDateEqual = (d1, d2) => {
  if (!d1 && !d2) {
    return true;
  }
  if (!d1 || !d2) {
    return false;
  }
  return compareCivilDate(d1, d2) === 0;
};

export const civilDateRangeEqual = (r1, r2) => {
  if ((!r1 && !r2) || (r1 === r2)) {
    return true;
  }
  if (!r1 || !r2) {
    return false;
  }
  return civilDateEqual(r1.start, r2.start) && civilDateEqual(r1.end, r2.end);
};

export const civilDateToDebugString = (cd) => {
  if (!cd) return '';
  const { year, month, day } = cd || {};
  return `${year || ''}-${month || ''}-${day || ''}`;
};

export const civilDateRangeToDebugString = (dr) => {
  if (!dr) {
    return '';
  }
  return `start:${civilDateToDebugString(dr.start)} end:${civilDateToDebugString(dr.end)}`;
};

export const getDefaultDateRange = () => {
  const yesterday = getCivilDateToday().plus({ days: -1 });
  const defaultRange = { start: yesterday, end: yesterday };
  return defaultRange;
};

export const getDefaultMetricDateRange = (i18n, dateFormat, timeZone, lcid) => {
  const todayObj = i18n.getToday({ timeZone });
  const today = new CivilDate(todayObj.year, todayObj.month, todayObj.day);
  const yesterday = today.plus({ days: -1 });
  const last30day = today.plus({ days: -30 });
  return {
    RangeStartDate: i18n.formatCivilDate(last30day, { raw: dateFormat, timeZone }),
    RangeEndDate: i18n.formatCivilDate(yesterday, { raw: dateFormat, timeZone }),
    Rangelcid: lcid,
    RangeId: 5, // last 30 days, RANGES.Last30Days
  };
};
